import { VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { Pressable } from "react-native";
import styled from "styled-components/native";
import { DefaultThemeValueType } from "../../../../styled";
import { SpaceType } from "@components/atoms/Spacer/types";

const RenderHeaderView = (
  setIsSelectLocationOpen: any,
  isSelectLocationOpen: any,
  localSelectedLocation: any,
  itemDetail: any,
  theme: DefaultThemeValueType,
  t: any,
  typography: any,
  title?: string
) => {
  return (
    <Pressable
      onPress={() => setIsSelectLocationOpen(!isSelectLocationOpen)}
      disabled={itemDetail?.locations?.length === 1}
    >
      <LocationContainer>
        <RowLocationContainer>
          <RowLocationChildContainer style={{ flex: 1 }}>
            <VDBIcon
              name={VDBIcons.LOCATION}
              size={24}
              color={theme["core-04"]}
              variant={IconsVariant.VDBCustom}
            />
            <LocationTitleContainer>
              <VDBText type={typography["Minor-R"]} color={theme["core-06"]}>
                {t(title || "productDetailPage.popup.locationTitle.text")}
              </VDBText>
              <VDBText
                type={typography["Body-M"]}
                color={theme["core-05"]}
                numberOfLines={2}
                ellipsizeMode="tail"
                style={{ flexShrink: 2 }}
              >
                {localSelectedLocation?.location_name}
              </VDBText>
            </LocationTitleContainer>
          </RowLocationChildContainer>
          <RowLocationChildContainer>
            <VDBIcon
              name={VDBIcons.FILLED_CIRCLE_DOWN}
              size={24}
              color={theme["main-01"]}
              variant={IconsVariant.VDBCustom}
            />
          </RowLocationChildContainer>
        </RowLocationContainer>
      </LocationContainer>
    </Pressable>
  );
};

const RowLocationContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const RowLocationChildContainer = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: ${SpaceType.Basic}px;
`;

const LocationContainer = styled.View<any>`
  background-color: ${({ theme }) => theme["core-01"]};
  align-items: flex-start;
  padding: 7px ${SpaceType.Extra}px;
  margin-bottom: 8px;
  /* margin-vertical: 10px; */
  border-radius: 7px;
  border-color: ${({ theme }) => theme["core-06"]};
  border-width: ${() => "1px"};
  align-items: flex-start; /* Align children vertically */
  justify-content: center; /* Align children horizontally */
`;

const LocationTitleContainer = styled.View`
  flex: 1;
  flex-direction: column;
  margin-left: 5px;
  gap: ${SpaceType.ExtraSmall}px;
`;

export default RenderHeaderView;
